import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import styled from 'styled-components';
import Sub from '../../../libs/Sub';

const InsertContainer = styled.div`
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 20;
    opacity: 0;
    transition: opacity 0.18s;
    display: flex;
    align-items: center;
    justify-content: center;

    /* Show when ancestor subtitle row is hovered */
    .subtitle-row-v2:hover & {
        opacity: 1;
    }

    &:hover {
        opacity: 1;
    }
`;

const StyledIconButton = styled(IconButton)`
    && {
        padding: 2px;
        background: #1e1e2e;
        border: 1px solid #4a9eff;
        color: #4a9eff;
        width: 22px;
        height: 22px;

        &:hover {
            background: rgba(74, 158, 255, 0.15);
        }
    }
`;

const NEW_SUB_DURATION = 2.0; // seconds for the newly inserted subtitle

/**
 * InsertSubtitleButton
 * Positioned between two subtitle rows. Shows on row-above hover.
 * Props:
 *   index   — index of the row ABOVE this button (new sub is inserted at index+1)
 *   sub     — the subtitle row above
 *   nextSub — the subtitle row below (may be undefined at end of list)
 *   addSub  — addSub(index, subObject) from SubtitleEditorV2
 */
export default function InsertSubtitleButton({ index, sub, nextSub, addSub }) {
    const handleInsert = () => {
        const gapStart = sub.endTime;
        const gapEnd = nextSub ? nextSub.startTime : sub.endTime + NEW_SUB_DURATION;
        const available = gapEnd - gapStart;
        const duration = Math.min(NEW_SUB_DURATION, Math.max(0.5, available - 0.05));

        const newSubStart = gapStart + 0.025;
        const newSubEnd = newSubStart + duration;

        addSub(
            index + 1,
            new Sub({
                startTime: newSubStart,
                endTime: Math.min(newSubEnd, nextSub ? nextSub.startTime - 0.025 : newSubEnd),
                text: '',
                text2: '',
                check: true,
            }),
        );
    };

    return (
        <InsertContainer>
            <Tooltip title="Insert subtitle here" placement="right" arrow>
                <StyledIconButton size="small" onClick={handleInsert} tabIndex={-1}>
                    <AddCircleOutlineIcon sx={{ fontSize: 14 }} />
                </StyledIconButton>
            </Tooltip>
        </InsertContainer>
    );
}
